import { render } from "./CreditCardPage.vue?vue&type=template&id=1ceef81b&ts=true"
import script from "./CreditCardPage.vue?vue&type=script&lang=ts"
export * from "./CreditCardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__